module.exports = __webpack_public_path__ + "img/Pulp_processing_stock.cc63908e.svg";